import React from "react";
import './LegalPages.scss';

const PrivacyPolicy = () => (
  <div className="legal-page">
    <h1>Politique de confidentialité</h1>
    <p>Dernière mise à jour : 7 août 2025</p>

    <h2>1. Qui sommes-nous ?</h2>
    <p>
      ReviewBoost AI, sbdev42@gmail.com.
    </p>

    <h2>2. Quelles données collectons-nous ?</h2>
    <ul>
      <li><strong>Données de compte :</strong> adresse e-mail, nom de l’entreprise.</li>
      <li><strong>Données de navigation :</strong> cookies, adresse IP, logs de connexion.</li>
      <li><strong>Données de contenu :</strong> avis, réponses, informations transmises via le formulaire.</li>
      <li><strong>Données techniques :</strong> type d’appareil, navigateur, logs d’erreurs.</li>
    </ul>

    <h2>3. Pourquoi collectons-nous vos données ?</h2>
    <ul>
      <li>Gestion de votre compte et sécurité</li>
      <li>Affichage, gestion et réponse aux avis clients</li>
      <li>Génération de réponses automatisées (IA)</li>
      <li>Statistiques d’utilisation et amélioration du service</li>
      <li>Alertes e-mail en cas d’avis négatif (si vous l’activez)</li>
    </ul>

    <h2>4. Bases légales du traitement</h2>
    <ul>
      <li>Exécution du contrat (gestion de votre compte)</li>
      <li>Consentement (cookies, alertes e-mail)</li>
      <li>Obligation légale (conservation des logs)</li>
      <li>Intérêt légitime (sécurité, amélioration du service)</li>
    </ul>

    <h2>5. Cookies & traceurs</h2>
    <p>
      Voir notre <a href="/cookies-policy" target="_blank" rel="noopener noreferrer">Politique de cookies</a>.
    </p>

    <h2>6. Combien de temps conservons-nous vos données ?</h2>
    <ul>
      <li><strong>Données de compte :</strong> jusqu’à suppression du compte</li>
      <li><strong>Données d’avis :</strong> 3 ans maximum (logs liés aux réponses IA)</li>
      <li><strong>Logs techniques :</strong> 12 mois maximum</li>
    </ul>

    <h2>7. Qui a accès à vos données ?</h2>
    <ul>
      <li>Équipe technique ReviewBoost AI</li>
      <li>Sous-traitants : hébergeur, OpenAI (pour génération IA).</li>
      <li>Vos données ne sont jamais revendues</li>
    </ul>

    <h2>8. Où sont stockées vos données ?</h2>
    <p>
      Serveurs situés en Europe [et/ou États-Unis si applicable].<br />
      Transferts encadrés par des clauses contractuelles types (SCC).
    </p>

    <h2>9. Quels sont vos droits ?</h2>
    <ul>
      <li>Accès, rectification, suppression, portabilité, limitation, opposition</li>
   
      <li>Droit d’introduire une réclamation auprès de la CNIL (<a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>)</li>
    </ul>

    <h2>10. Sécurité</h2>
    <p>
      Vos données sont protégées par chiffrement (TLS 1.3, AES-256), accès restreint, audits réguliers.
    </p>

    <h2>11. Modification de la politique</h2>
    <p>
      Nous pouvons mettre à jour cette politique. Toute modification sera notifiée sur cette page.
    </p>
  </div>
);

export default PrivacyPolicy;
